import { _ as _assign, b as __awaiter, c as __generator } from '../tslib.es6-c6da0ae6.js';
import fetch from 'isomorphic-fetch';
import LRU from '../LRUCache/index.js';
import { LANGUAGE_HEADER_KEY, CURRENT_LANGUAGE_COOKIE_NAME } from '../configs/constants/index.js';
import IS_BROWSER from '../isBrowser/index.js';
import { authorizationHeader } from '../services/auth/index.js';
import getDeviceId from '../getDeviceId/index.js';
import RequestStore from '../RequestStore/index.js';
import { getCookie } from '../cookie/index.js';

var lruCache = new LRU(50);
var makeUnique = function makeUnique(url, method, data) {
  return "".concat(url, "-").concat(method, "-").concat(data);
};
var getRequestOptions = function getRequestOptions(options) {
  var myHeaders = new Headers();
  options.headers && Object.entries(options.headers).forEach(function (_a) {
    var key = _a[0],
      value = _a[1];
    return myHeaders.append(key, value);
  });
  return _assign(_assign({}, options), {
    headers: myHeaders
  });
};
var getDeviceIdAndLanguage = function getDeviceIdAndLanguage(device, language) {
  var _a;
  return _assign(_assign({}, device && getDeviceId() && {
    deviceId: getDeviceId()
  }), language && (_a = {}, _a[LANGUAGE_HEADER_KEY] = getCookie(CURRENT_LANGUAGE_COOKIE_NAME), _a));
};
var getHeaders = function getHeaders(initialHeaders, options) {
  return {
    headers: _assign(_assign({}, initialHeaders), options === null || options === void 0 ? void 0 : options.headers)
  };
};
var getOptions = function getOptions(initialHeaders, options, withDeviceId, withLanguageHeader) {
  return _assign(_assign(_assign({}, options), getHeaders(initialHeaders || {}, options)), getDeviceIdAndLanguage(withDeviceId, withLanguageHeader));
};
var getFromCache = function getFromCache(hash) {
  return lruCache.read(hash);
};
var cacheResults = function cacheResults(res, useCache, hash) {
  if (res.status === 200 && useCache) {
    lruCache.set(hash, res);
  }
};
var handleRequest = function handleRequest(url, options, useCache) {
  if (useCache === void 0) {
    useCache = true;
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var hash, result, request, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          hash = makeUnique(url, options.method || 'GET', options);
          if (useCache && lruCache.has(hash)) return [2, getFromCache(hash)];
          _a.label = 1;
        case 1:
          _a.trys.push([1, 6,, 7]);
          result = void 0;
          if (!IS_BROWSER) return [3, 3];
          request = fetch(url, getRequestOptions(options));
          RequestStore.set(hash, request);
          return [4, request];
        case 2:
          result = _a.sent();
          RequestStore.drop(hash);
          return [3, 5];
        case 3:
          return [4, fetch(url, getRequestOptions(options))];
        case 4:
          result = _a.sent();
          _a.label = 5;
        case 5:
          cacheResults(result, useCache, hash);
          return [2, result];
        case 6:
          error_1 = _a.sent();
          console.error('Error handling your request:', error_1);
          throw error_1;
        case 7:
          return [2];
      }
    });
  });
};
function fetchFactory(configs) {
  var _this = this;
  var baseUrl = configs.baseUrl,
    cacheEnabled = configs.withCache,
    headers = configs.headers,
    withDeviceId = configs.withDeviceId,
    withLanguageHeader = configs.withLanguageHeader,
    accessToken = configs.accessToken;
  var headersWithAuth = _assign(_assign({}, authorizationHeader(accessToken)), headers);
  return function (url, options, withCache) {
    return __awaiter(_this, void 0, void 0, function () {
      var error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, handleRequest("".concat(baseUrl).concat(url), getOptions(headersWithAuth, options, withDeviceId, withLanguageHeader), withCache !== null && withCache !== void 0 ? withCache : cacheEnabled)];
          case 1:
            return [2, _a.sent()];
          case 2:
            error_2 = _a.sent();
            console.error('Error handling your request:', error_2);
            throw error_2;
          case 3:
            return [2];
        }
      });
    });
  };
}

export { fetchFactory as default };
//# sourceMappingURL=index.js.map
